import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {REPORT_JOB_TYPES} from '../shared/reportJobLists';
import {filterStyles} from '../shared/styles-filter';
import VirtualizedSelectInput from './VirtualizedSelectInput';

/**
 * A form containing a SelectInput component with Report Job Type choices
 *
 */
class ReportJobsFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportTypeId: ''
        };
        this.handleReportTypeFilterChange = this.handleReportTypeFilterChange.bind(this);
    }

    handleReportTypeFilterChange(event, index, value) {
        const reportTypeValue = (index && index !== value) ? index : '';
        this.setState({
            reportTypeId: reportTypeValue
        }, () => {
            this.props.dispatch(change('reportJobFilterForm', 'report_job_filter_report_type', this.state.reportTypeId));
            if (typeof this.props.onFilterChange === 'function') {
                this.props.onFilterChange({type: 'report-type', value: this.state.reportTypeId});
            }
        });
    }

    createReportTypeChoices() {
        let choices = [];
        for (let i = 0; i < REPORT_JOB_TYPES.length; i++) {
            const name = (this.props.fullWidth) ? REPORT_JOB_TYPES[i].long_name : REPORT_JOB_TYPES[i].name;
            const choice = {
                id: REPORT_JOB_TYPES[i].id,
                name: name
            };
            choices.push(choice);
        }
        return choices;
    }

    render() {
        const {clearable, fullWidth, instructions} = this.props;
        const {reportTypeId} = this.state;

        const styles = {
            fieldStyle: (fullWidth) ? filterStyles.selectInputFull : filterStyles.selectInputWide,
            instructions: {fontSize: 12, margin: '1em 0 -1em 0'}
        };

        const choices = this.createReportTypeChoices();

        return (
            <div style={filterStyles.reportFilter}>
                {instructions &&
                    <div style={styles.instructions}>
                        If desired, filter by Report Job Type.
                    </div>
                }
                <Field name="filter_report_job_report_type"
                       component={VirtualizedSelectInput}
                       choices={choices}
                       label="Filter by Report Type"
                       optionValue="id"
                       allowEmpty
                       options={{
                           value: reportTypeId,
                           clearable: clearable
                       }}
                       onChange={this.handleReportTypeFilterChange}
                       elStyle={styles.fieldStyle}
                       className="input half-width"
                />
            </div>
        );
    }
}

ReportJobsFilter.propTypes = {
    addField: PropTypes.bool,
    clearable: PropTypes.bool,
    fullWidth: PropTypes.bool,
    instructions: PropTypes.bool,
    onFilterChange: PropTypes.func
};

ReportJobsFilter.defaultProps = {
    addField: true,
    clearable: true,
    fullWidth: false,
    instructions: false
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'reportJobFilterForm',
        enableReinitialize: true
    })
);

export default enhance(ReportJobsFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobsFilter.js